const version = {
  number: '0.2.0',
};

export default version;
